import { Heading, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { EditOrganizationUnit } from 'BrokerTsLib/src/dtos'
import {
  useGetOrganizationUnitById,
  useGetOrganizationUnitProperties,
  useGetPossibleTypes,
  useUpdateOrganizationUnit,
} from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useNavigate, useParams } from 'react-router-dom'

import { Container } from '../../components/Container'
import { Loading } from '../../components/Loading'
import { Section } from '../../components/Section'
import { OrganizationEditForm } from '../../containers/organization/OrganizationEditForm'
import { PageContent } from '../../containers/PageContent'

export const OrganizationEditPage = () => {
  const navigate = useNavigate()
  const toast = useToast()
  const { organizationUnitId: organizationUnitIdParam } = useParams()
  const organizationUnitId = Number(organizationUnitIdParam)

  const { data: organizationData, isLoading: isLoadingOrganization } =
    useGetOrganizationUnitById(organizationUnitId)
  const { data: propertiesData, isLoading: isLoadingProperties } =
    useGetOrganizationUnitProperties(organizationUnitId)
  const { mutateAsync: update } = useUpdateOrganizationUnit()
  const { data } = useGetPossibleTypes(Number(organizationUnitId))
  const possibleTypes = Array.from(
    new Set(
      (organizationData &&
        data && [organizationData?.data.type, ...(data?.data ?? [])]) ||
        [],
    ),
  )

  const onSubmit = (values: EditOrganizationUnit) =>
    update(values)
      .then((response) => {
        navigate('/organization/' + values.id)

        return response
      })
      .catch((e: AxiosError) => {
        toast({
          title: 'Chyba při ukládání organizace',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        return e
      })

  const isLoading = isLoadingOrganization || isLoadingProperties

  return (
    <Section>
      <Container>
        <PageContent>
          <Heading>Upravit organizaci</Heading>
          {isLoading || !organizationData || !propertiesData ? (
            <Loading large />
          ) : (
            <OrganizationEditForm
              organization={organizationData.data}
              properties={propertiesData.data}
              onSubmit={onSubmit}
              possibleTypes={possibleTypes}
            />
          )}
        </PageContent>
      </Container>
    </Section>
  )
}
